import React, { Component } from 'react';
import { Tree } from 'antd';
import styles from './index.less';

const { TreeNode } = Tree;

export default class TreeSelectChannel extends Component {
  onSelect = selectedKeys => {
    const { params, fetchPublishList, setChannelId } = this.props;
    fetchPublishList({
      ...params,
      page: 1,
      channelId: selectedKeys[0] === '0' ? '' : selectedKeys[0],
    });
    setChannelId(selectedKeys[0] === '0' ? '' : selectedKeys[0]);
  };

  render() {
    const { channelList } = this.props;
    if (!channelList || channelList.length <= 0) {
      return null;
    }
    return (
      <Tree
        defaultExpandAll
        blockNode
        onSelect={this.onSelect}
        defaultSelectedKeys={['0']}
        className={styles['tree-select-channel']}
      >
        {channelList.map(item => {
          return (
            <TreeNode title={item.label} key={item.value}>
              {item.children &&
                item.children.map(ele => {
                  return (
                    <TreeNode title={ele.label} key={ele.value} disabled={ele.children.length > 0}>
                      {ele.children &&
                        ele.children.map(sub => {
                          return <TreeNode title={sub.label} key={sub.value} />;
                        })}
                    </TreeNode>
                  );
                })}
            </TreeNode>
          );
        })}
      </Tree>
    );
  }
}
